var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-3"},[(_vm.isFFForUnset)?_c('fff-dashboard-panel'):_c('cnc-dashboard-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }